import orm from 'models'
import { createSelector as ormSelector } from 'redux-orm'
import { createSelector } from 'reselect'
import getEntities from 'selectors/entities'

const mapEmployment = (session) => (employment) => {
  const { ref } = employment
  return { ...ref,
    user: session.user.withId(employment.userId),
    teamNames:  session.team.all().toModelArray()
                       .filter((team) => team.members.includes(employment.id))
                       .map((team) => team.name)
                       .filter((name) => name !== 'Iedereen')
  }
}

export const getAllEmployments = ormSelector(orm, getEntities, (session) => {
  return session.employment.all().toModelArray().map(mapEmployment(session))
})

export const getEmployments = ormSelector(orm, getEntities, (session) => {
  return session.employment.all().toModelArray()
    .filter(e => !e.deactivatedAt)
    .map(mapEmployment(session))
})

export const getCurrentEmployment = createSelector([getEmployments],
  (employments) => {
    return employments.find( employment =>  { return employment.current})
  }
)

export const getPractioners = createSelector([getEmployments], (employments) => {
    return employments.filter( employment => { return ( employment.roles.includes("practitioner")) })
})
